import { CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material'
import { useContext, useState } from 'react'
import { approveMicroLearning } from '../../../api/api'
import { MicroLearningDetailResponse } from '../../../api/models'
import { AppStateContext } from '../../../state/AppProvider'
import ApproveModalContent from './ApproveModalContent'
import { MicroLearningActionModal } from './MicroLearningActionModal'

type ApproveModalProps = {
  open: boolean
  onClose: () => void
  mlId: string
  data: MicroLearningDetailResponse | null
  onSuccess: () => void
}

export default function ApproveModal({ open, onClose, mlId, data, onSuccess }: ApproveModalProps) {
  const appStateContext = useContext(AppStateContext)
  const [selectedOus, setSelectedOus] = useState<string[]>([])
  const [note, setNote] = useState('')
  const [isApproving, setIsApproving] = useState(false)

  const handleClose = () => {
    setSelectedOus([])
    setNote('')
    onClose()
  }

  const handleToggleOu = (ou: string) => {
    setSelectedOus(prev => (prev.includes(ou) ? prev.filter(o => o !== ou) : [...prev, ou]))
  }

  const handleConfirm = async () => {
    if (!mlId || selectedOus.length === 0) return
    setIsApproving(true)
    const result = await approveMicroLearning(mlId, selectedOus, note || undefined)
    setIsApproving(false)

    if (result.success) {
      handleClose()
      onSuccess()
      appStateContext?.dispatch({
        type: 'SET_SNACKBAR_STATE',
        payload: { message: 'Micro-learning approved successfully', severity: 'success' },
      })
    } else {
      appStateContext?.dispatch({
        type: 'SET_SNACKBAR_STATE',
        payload: {
          message: 'Failed saving Micro-learning changes. Try again later',
          severity: 'warning',
        },
      })
    }
  }

  return (
    <MicroLearningActionModal
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      confirmText='Approve'
      confirmDisabled={selectedOus.length === 0 || isApproving}
      theme='green'
      headerIcon={<CheckCircleOutlineIcon style={{ color: '#1B5E20', fontSize: 20 }} />}
      title='Approve'
      subtitle='This will approve the micro-learning to all target OUs'
      mlId={data?.ml_id || '—'}
      mlTitle={data?.generation?.title || data?.title || 'Micro-Learning'}
      score={data?.score}>
      <ApproveModalContent
        selectedOus={selectedOus}
        onToggleOu={handleToggleOu}
        note={note}
        onNoteChange={setNote}
      />
    </MicroLearningActionModal>
  )
}
